import { useRef, useState } from 'react'
import classNames from 'classnames'

import { useResizeObserver } from '../../../../hooks'
import { getChartAnchoredTooltipLeft } from '../ChartAnchoredTooltip.utils'

import * as styles from './ChartAnchoredTooltipBox.module.css'

function ChartAnchoredTooltipBox({ children, isInsidePlot, plotArea, top, x }) {
  const [width, setWidth] = useState(0)

  const boxRef = useRef(null)

  function handleResize(node) {
    setWidth(node.offsetWidth)
  }

  useResizeObserver({ callback: handleResize, ref: boxRef })

  return (
    <span
      className={classNames(styles.box, { [styles.inside]: isInsidePlot })}
      ref={boxRef}
      style={{
        left: getChartAnchoredTooltipLeft({ plotArea, width, x }),
        top: top ?? plotArea.y,
      }}
    >
      {children}
    </span>
  )
}

export default ChartAnchoredTooltipBox
